import { Positions } from "./usePositions"

export function usePositionMaker(tickerSymbol: string) {
    const { positionDataAllByMarket } = Positions.useContainer()
    const position = positionDataAllByMarket ? positionDataAllByMarket[tickerSymbol]?.makerPosition : undefined
    return position
}
